import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "text-xl font-base text-gray-900" }




export default /*#__PURE__*/_defineComponent({
  props: {
  homeId: {
    type: String,
    required: false,
    default: '123',
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " HomeId: (" + _toDisplayString(props.homeId) + ") ", 1)
  ]))
}
}

})